var LinkablePlansFactory = function ($resource) {
    var retrievePlansAvailableForLinkingForProfile =
        "/participant-web-services/rest/partialauth/oneId/retrieveLinkablePlans?flowName=profile";
    var retrievePlansAvailableForLinking =
        "/participant-web-services/rest/partialauth/oneId/retrieveLinkablePlans";
    var skipAndNavigate = "/participant-web-services/rest/partialauth/oneId/skipAndNavigate";
    var linkAccounts = "/participant-web-services/rest/partialauth/oneId/linkAccounts";
    var isMfaFinishedPrior =
        "/participant-web-services/rest/partialauth/oneId/isMfaFinishedPrior/:indId/:dbName";

    return {
        retrievePlansAvailableForLinking: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retrievePlansAvailableForLinking,
            {},
            {
                query: {
                    method: "GET"
                }
            }
        ),

        retrievePlansAvailableForLinkingForProfile: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retrievePlansAvailableForLinkingForProfile,
            {},
            {
                query: {
                    method: "GET"
                }
            }
        ),

        linkAccounts: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + linkAccounts,
            {
                key: "@key"
            },
            {
                query: {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),

        skipAndNavigate: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + skipAndNavigate,
            {
                key: "@key"
            },
            {
                query: {
                    method: "GET"
                }
            }
        ),

        isMfaFinishedPrior: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + isMfaFinishedPrior,
            {
                indId: "@indId",
                dbName: "@dbName"
            },
            {
                query: {
                    method: "GET"
                }
            }
        )
    };
};

LinkablePlansFactory.$inject = ["$resource"];
export default LinkablePlansFactory;
